import { createWebHistory, createRouter } from "vue-router";
import { canActivate } from '@/services/auth-guard.service';
import MainLayout from "@/layouts/MainLayout.vue";
import NoMenuLayout from "@/layouts/NoMenuLayout.vue";

const routes = [
  {
    path: "/",
    component: NoMenuLayout,
    children: [
      { path: "", redirect: "/main" },
      { path: "init", component: () => import("@/views/Init.vue") },
      { path: "callback", component: () => import("@/views/Callback.vue") }
    ]
  },
  {
    path: "/main",
    component: MainLayout,
    children: [
      { path: "", name: "Home", component: () => import('@/views/Home.vue') },
      { path: "order/:id", name: "Order Detail", component: () => import('@/views/Order.vue') },
      {
        path: "discounts",
        component: "",
        children: [
          { path: "", name: "Discounts", component: () => import('@/views/Discounts/Index.vue') },
          { path: "new", name: "New Discount", component: () => import('@/views/Discounts/New.vue') },
          { path: "edit/:id", name: "Update Discount", component: () => import('@/views/Discounts/Edit.vue') }
        ]
      },
      { path: "rules", name: "Rules", component: () => import('@/views/Rules.vue') },
      { path: "settings", name: "Settings", component: () => import('@/views/Settings/Index.vue') },
      { path: "payment-gateways", name: "Payment Gateways", component: () => import('@/views/PaymentGateways.vue') },
    ],
    beforeEnter: (to, from, next) => {
      next(canActivate())
    }
  },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // Browser back/forward buttons
        if (savedPosition) {
            return savedPosition
        }

        // Scroll to top on route change
        return { top: 0 }
    }
});

router.afterEach((to) => {
  document.title = to.name ?? "OMS"
});

export default router;